/**
 * Кольцевой индикатор прогресса с текстом в центре.
 * Используется на Result top-fold (балл «8/11») и Welcome preview-card.
 *
 * Props:
 *  - value/max: дробь для расчёта заполнения (0..1).
 *  - center: текст в центре (например, «8/11» для балла).
 *  - size: размер круга в px.
 */

interface RingProgressProps {
  value: number;
  max: number;
  center: string;
  size?: number;
  className?: string;
}

export function RingProgress({
  value,
  max,
  center,
  size = 72,
  className,
}: RingProgressProps) {
  const safeMax = Math.max(max, 1);
  const safeValue = Math.max(0, Math.min(value, safeMax));
  const ratio = safeValue / safeMax;
  const stroke = 6;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - ratio);

  return (
    <div className={className} style={{ width: size, height: size, position: 'relative' }}>
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} aria-hidden="true">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="rgb(var(--color-border))"
          strokeWidth={stroke}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="rgb(var(--color-accent))"
          strokeWidth={stroke}
          strokeLinecap="round"
          fill="none"
          strokeDasharray={c}
          strokeDashoffset={offset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{ transition: 'stroke-dashoffset 600ms ease-out' }}
        />
      </svg>
      <div
        className="absolute inset-0 flex items-center justify-center text-base font-bold text-text-primary"
        aria-label={`${safeValue} из ${safeMax}`}
      >
        {center}
      </div>
    </div>
  );
}
